import { run } from "remix/ui";

import { setupScrollEffects } from "./scroll-effects.ts";

let app = run({
  async loadModule(moduleUrl, exportName) {
    let mod = await import(moduleUrl);
    return mod[exportName];
  },
  async resolveFrame(src, signal) {
    let response = await fetch(src, {
      headers: { Accept: "text/html" },
      signal,
    });
    if (!response.ok) {
      return `<pre>Frame error: ${response.status} ${response.statusText}</pre>`;
    }

    if (response.body) return response.body;
    return await response.text();
  },
});

app.addEventListener("error", (event) => {
  console.error("Component error:", event.error);
});

void app.ready().then(() => setupScrollEffects());
